/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Modal, Tooltip } from "@forge/common";
export interface DeleteProps {
  handleClose(): void;
  DeleteConfirmationMessage: string;
  open: boolean;
  handleDeleteConfirmation(): void;
  title: string;
  subTitle: string;
}

const DeleteDialog = (props: DeleteProps) => {
  return (
    <>
      {props.open && (
        <Modal
          className="contentDialogDelete mx-auto"
          backdrop
          footerLeft={
            <Button variant="secondary" onClick={props.handleClose}>
              Cancel
            </Button>
          }
          footerRight={
            <Button
              variant="primary"
              onClick={props.handleDeleteConfirmation}
              type="submit"
            >
              Confirm
            </Button>
          }
          // label="Confirmation"
          // onBackdropClick={function noRefCheck() {}}
          onModalClose={props.handleClose}
          title={props.title}
        >
          <div
            style={{
              height: "max-content",
              lineHeight: "normal",
            }}
          >
            <div>{props.DeleteConfirmationMessage}</div>
            <div>{props.subTitle} </div>
          </div>
        </Modal>
      )}
    </>
  );
};
/// end return Dialog

export default DeleteDialog;
